{
  "todayButton": "היום",
  "nextMonth": "חודש הבא",
  "previousMonth": "חודש קודם",
  "nextYear": "שנה הבאה",
  "previousYear": "שנה קודמת",
  "weekdays": ["א", "ב", "ג", "ד", "ה", "ו", "ש"],
  "months": [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר"
  ]
}
